<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Gyermek órarendje</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <!-- Tanulói belépésnél nincs mit választani: a saját nevét írjuk ki, rögzítve.
           Legördülővel a képernyő azt sugallná, hogy van másik választás is. -->
      <ion-col size="12" sizeLg="5" *ngIf="sajatSor">
        <ion-input label="Tanuló" label-placement="stacked" fill="outline" readonly
                   [value]="sajatSor.full_name || sajatSor.name">
          <ion-icon slot="start" name="person" aria-hidden="true"></ion-icon>
        </ion-input>
      </ion-col>
      <ion-col size="12" sizeLg="5" *ngIf="!sajatSor">
        <ion-select
          interface="popover"
          label="Gyermek"
          label-placement="stacked"
          fill="outline"
          [(ngModel)]="kivtanulo"
          (ionChange)="onTanuloValtozas($event.detail.value)">
          <ion-select-option *ngFor="let gyerek of gyerekek" [value]="gyerek.oktazon">
            {{ gyerek.name }}
          </ion-select-option>
        </ion-select>
      </ion-col>
      <!-- NEM TANÓRAI CÉLÚ FOGLALKOZÁSOK: alapból rejtve. Csak a gondviselő kapcsolhatja be,
           és csak akkor látszik a kapcsoló, ha a gyermeknek van ilyen foglalkozása.
           A beállítás a gyermekre szól: a saját belépésén is érvényes. -->
      <ion-col size="12" sizeLg="7" *ngIf="nemTanorai?.van && nemTanorai?.modosithato">
        <ion-item lines="none" class="nem-tanorai-kapcsolo">
          <ion-icon slot="start" name="people-outline" color="medium" aria-hidden="true"></ion-icon>
          <ion-label class="ion-text-wrap">
            Nem tanórai foglalkozások
            <p>
              Korrepetálás, felkészítés, napközi, szakkör. Alapból rejtve; a bekapcsolás a gyermek saját
              belépésére is érvényes.
              <span *ngIf="!nemTanorai?.lathato && nemTanorai?.rejtett">Ezen a héten {{ nemTanorai?.rejtett }} ilyen óra van elrejtve.</span>
            </p>
          </ion-label>
          <ion-toggle slot="end" [checked]="nemTanorai?.lathato" aria-label="Nem tanórai foglalkozások megjelenítése"
                      (ionChange)="nemTanoraiValt($event.detail.checked)"></ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card *ngIf="!gyerekek?.length">
    <ion-card-content>
      Ehhez a felhasználóhoz jelenleg nincs gyermek hozzárendelve.
    </ion-card-content>
  </ion-card>

  <!-- ONLINE ÓRÁK (digitális munkarend): a tanár a naplóban rögzítette a linket. A „Csatlakozás”
       az óra idején aktív (15 perccel előtte nyílik), a naptárban az órára kattintva is működik. -->
  <ion-card *ngIf="kivtanulo && latszoOnlineOrak.length" class="online-orak">
    <ion-card-header>
      <ion-card-title><ion-icon name="videocam-outline" aria-hidden="true"></ion-icon> Online órák ezen a héten</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-item *ngFor="let o of latszoOnlineOrak" lines="none">
        <ion-label class="ion-text-wrap">
          <b>{{ o.cim }}</b>
          <p>{{ onlineIdo(o) }}</p>
        </ion-label>
        <ion-button slot="end" [disabled]="!csatlakozhato(o)" (click)="csatlakozas(o)">
          <ion-icon slot="start" name="log-in-outline"></ion-icon>Csatlakozás
        </ion-button>
      </ion-item>
      <ion-note color="medium">A gomb az óra kezdete előtt 15 perccel válik aktívvá.</ion-note>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="kivtanulo">
    <ion-card-header>
      <ion-card-title>Órarend</ion-card-title>
      <ion-card-subtitle>{{ headerTitle }}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <div class="toolbar-row">
        <div class="calendar-actions">
          <button type="button" class="calendar-native-button" (click)="prev()" aria-label="Előző időszak" title="Előző időszak">
            <ion-icon name="arrow-back" aria-hidden="true"></ion-icon>
          </button>
          <button type="button" class="calendar-native-button" (click)="today()">Ma</button>
          <button type="button" class="calendar-native-button" (click)="next()" aria-label="Következő időszak" title="Következő időszak">
            <ion-icon name="arrow-forward" aria-hidden="true"></ion-icon>
          </button>
        </div>

        <div class="calendar-actions">
          <button
            type="button"
            class="calendar-native-button"
            [class.active]="view === 'workWeek'"
            (click)="changeView('workWeek')">
            Hétfő-péntek
          </button>
          <button
            type="button"
            class="calendar-native-button"
            [class.active]="view === 'workWeekSat'"
            (click)="changeView('workWeekSat')">
            Szombattal
          </button>
        </div>
      </div>

      <ion-progress-bar *ngIf="loading" type="indeterminate"></ion-progress-bar>
      <ion-note *ngIf="!loading && uresOrarend" color="medium" class="empty-note">
        A kiválasztott héten nincs megjeleníthető óra ehhez a gyermekhez.
      </ion-note>

      <div class="calendar-shell">
        <full-calendar #cal [options]="calendarOptions" [deepChangeDetection]="true"></full-calendar>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
